import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedApp from './ProtectedApp';
import Home from './Home';
import Detail from './Detail';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:linkId" element={<ProtectedApp />}>
          <Route index element={<Home />} />
          <Route path="detail" element={<Detail />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
